module.exports = __webpack_public_path__ + "img/chat_c.d4a4d64e.png";